export default "__VITE_ASSET__C$XI_VWg__"